'use strict';

var React = require('react');

var SvgFavoriteMajor = function SvgFavoriteMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m5 12-3.624-3c-.684-.547-.384-1.647.484-1.771l5.14-.229 2.195-5.503a.9.9 0 0 1 1.61 0l2.195 5.503 5.14.229c.868.124 1.168 1.224.484 1.771l-3.624 3 .989 5.857a1 1 0 0 1-1.437 1.036l-4.552-2.893-4.552 2.892a1 1 0 0 1-1.437-1.036l.989-5.856z"
  }));
};

exports.SvgFavoriteMajor = SvgFavoriteMajor;
